import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { ErrorHandlerService } from '../../core/services/error-handler.service';
import { CityTaxSummaryService } from '../../services';

import * as fromActions from './actions';

@Injectable()
export class CityTaxSummaryStatisticsStoreEffects {
  constructor(
    private actions$: Actions,
    private dataService: CityTaxSummaryService,
    private errorHandler: ErrorHandlerService,
  ) {}

  load$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.loadRequest),
      switchMap(() =>
        this.dataService.loadStatistics().pipe(
          map(() => fromActions.loadSuccess()),
          catchError((error) => {
            this.errorHandler.handle(error);
            return of(fromActions.loadFailure(error));
          }),
        ),
      ),
    ),
  );
}
